import axios from "axios";
import React from "react";
import { Component } from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import { api_url } from "./Constants";
import Home from "./Home";
import News from "./News";
import Rechoose from "./Rechoose";
import SettingComponent from "./SettingComponent";
import Story from "./StoryComponent";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      islanguage: true,
    };
  }

  componentDidMount() {
    let language_id = localStorage.getItem("languageId");
    let path_full = window.location.pathname;
    let portal = path_full.split("/");
    portal = portal[portal.length - 1];
    console.log(portal);
    if (portal == "rionetwork") {
      localStorage.setItem("from_portal", "rionetwork");
    } else {
      localStorage.setItem("from_portal", "cachc");
    }
    if (language_id == null) {
      this.setState({ islanguage: false });
    } else {
      this.setState({ islanguage: true });
    }
    axios.defaults.baseURL = api_url;
    console.log("localstorage_data", this.state.islanguage);
  }

  render() {
    return (
      <Router basename="/library/">
        <Switch>
          <Route
            exact
            path="/"
            component={() => (this.state.islanguage ? <News /> : <Home />)}
          />
          <Route
            exact
            path="/rionetwork"
            component={() => (this.state.islanguage ? <News /> : <Home />)}
          />
          <Route exact path="/list" component={News} />
          <Route exact path="/detail/:id" component={SettingComponent} />
          <Route exact path="/story" component={Story} />
          <Route exact path="/rechoose_language" component={Home} />
        </Switch>
      </Router>
    );
  }
}

export default App;
